import { render } from "./Card.vue?vue&type=template&id=f7bc63da&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=f7bc63da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f7bc63da"

export default script